const SEARCH_IMAGE_KEY = "search-image";

export { SEARCH_IMAGE_KEY };
